import { Dashboard } from './dashboardModel';

export function getDashboardConnectionError(dashboard: Dashboard) {
    return dashboard.connection.kind === 'error' ? dashboard.connection.error : null;
}
